import { AlertCircle, ImageIcon } from 'lucide-react'
import { IconImage } from 'src/pages/Home/components/IconImage'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { cn } from 'src/shared/components/ui/utils'

export const LogoFetchMessage = ({
  content,
  selectedLogoUrl,
  onSelectLogo,
}: {
  content: {
    message?: string
    success?: boolean
    data?: {
      domain?: string
      logos?: string[]
    }
  }
  selectedLogoUrl?: string | null
  onSelectLogo?: (url: string) => void
}) => {
  const { t } = useLocalization()
  const logos = content.data?.logos ?? []
  const domain = content.data?.domain
  const failed = content.success === false || logos.length === 0

  return (
    <Column
      className={cn(
        'gap-2 rounded-lg border px-3 py-2',
        failed
          ? 'border-amber-200 bg-amber-50'
          : 'border-violet-200 bg-violet-50'
      )}
    >
      <Row className="items-center gap-2">
        {failed ? (
          <AlertCircle className="h-4 w-4 shrink-0 text-amber-700" />
        ) : (
          <ImageIcon className="h-4 w-4 shrink-0 text-violet-700" />
        )}
        <p className={failed ? 'text-sm text-amber-900' : 'text-sm text-violet-900'}>
          {content.message ||
            (failed
              ? t(
                  'I could not find a logo on that website.',
                  'Jag hittade ingen logotyp på den webbplatsen.'
                )
              : t(
                  domain
                    ? `We found logos for ${domain}. Pick the one you'd like on your merch`
                    : 'Pick the logo you want on your merch',
                  domain
                    ? `Vi hittade logotyper för ${domain}. Välj den du vill ha på era profilprodukter`
                    : 'Välj den logotyp du vill ha på era profilprodukter'
                ))}
        </p>
      </Row>

      {logos.length > 0 && (
        <Row className="flex-wrap gap-2">
          {logos.map((url) => (
            <IconImage
              key={url}
              src={url}
              selected={selectedLogoUrl === url}
              onClick={() => onSelectLogo?.(url)}
              className="h-20 w-20"
            />
          ))}
        </Row>
      )}
    </Column>
  )
}
